import { COIN_ACCOUNT, COIN_JS_ORDER, COIN_QR_ORDER, COIN_TRADE_LIST, type CommonResponse, netClient } from '@/apis/api'
import { defineStore } from 'pinia'
import type { CreateOrderNativeResponse, CreateWechatOrderResponse } from '../payment'
import { inMiniprograme, isIOS, renderMessage } from '@/utils/util'
import { handleErr } from '@/composables/exception/handler'
import { CODE_OK } from '@/apis/code'
import { ElMessage } from 'element-plus'
import { computed, ref, type Ref } from 'vue'
import type { MemorialGiftDTO } from '../memorize/memorize'
import { useLocalStorage } from '@vueuse/core'
import { useUserLocalStorage } from '../user/users'

export async function tryGetCoinAccount() {
  const store = useCoinStore()

  console.log('coin.valu开始请求思念豆数据')
  const { data, error, statusCode } = await getCoinAccount()
  if (error.value) {
    handleErr(data, error, statusCode)
  } else {
    const resData = data as unknown as Ref<CommonResponse<CoinAccountResponse>>
    if (resData.value.code === CODE_OK) {
      const result = resData.value.data
      if (result.coinAccount !== null) {
        console.log('result.coinAccount.balance', result.coinAccount.balance)
        console.log('store.getCoin()1', store.getCoin())
        store.updateCoin(result.coinAccount.balance)
        console.log('store.getCoin()2', store.getCoin())
      }
      store.updateTopupPlans(result.topupPlans)
    } else {
      ElMessage({
        message: renderMessage(resData.value.message),
        type: 'warning'
      })
    }
  }
}

const coinStorage = useUserLocalStorage<{
  coin: number
}>('coinUserStorage', () => {
  return {
    coin: 0
  }
})

const coinTopupPlanStorage = useLocalStorage<{
  topupPlans: CoinTopupPlan[]
}>(
  'coinTopupPlansStorage',
  () => {
    return {
      topupPlans: []
    }
  },
  {
    serializer: {
      read: (v) => {
        if (!v) {
          return { topupPlans: [] }
        }
        try {
          const parsed = JSON.parse(v) as Record<string, any>
          if (Array.isArray(parsed.topupPlans)) {
            return {
              topupPlans: parsed.topupPlans
            }
          }
          const firstBucket = Object.values(parsed).find((item) =>
            Array.isArray((item as Record<string, any>)?.topupPlans)
          )
          const candidateList = (firstBucket as Record<string, any> | undefined)?.topupPlans
          return {
            topupPlans: Array.isArray(candidateList) ? (candidateList as CoinTopupPlan[]) : []
          }
        } catch {
          return { topupPlans: [] }
        }
      },
      write: (v) =>
        JSON.stringify({
          topupPlans: Array.isArray(v?.topupPlans) ? v.topupPlans : []
        })
    }
  }
)

export const useCoinStore = defineStore('coin', () => {
  const coin = ref(coinStorage.value.coin || 0)

  const topupPlans = computed({
    get: () => coinTopupPlanStorage.value.topupPlans,
    set: (val) => (coinTopupPlanStorage.value.topupPlans = val)
  })

  // 操作方法
  const updateCoin = (newCoin: number) => {
    console.log('updateCoin called, old:', coin.value, 'new:', newCoin)
    coin.value = newCoin
    coinStorage.value.coin = newCoin
  }

  const updateTopupPlans = (newPlans: CoinTopupPlan[]) => {
    topupPlans.value = [...newPlans]
  }

  const getCoin = () => {
    return coin.value
  }

  const getTopupPlans = computed(() => topupPlans.value)

  return {
    coin,
    topupPlans,
    updateCoin,
    updateTopupPlans,
    getCoin,
    getTopupPlans
  }
})

export interface CoinAccountResponse {
  topupPlans: Array<CoinTopupPlan>
  coinAccount: CoinAccountDTO
}

export interface CoinAccountDTO {
  id: string
  userId: string
  balance: number
}

export interface CoinTopupPlan {
  coinAmount: number
  price: number
  discountRate: number
  key: string
}

export const getCoinAccount = () => {
  return netClient.request<CommonResponse<CoinAccountResponse>>(COIN_ACCOUNT, 'get', {
    iosMiniapp: isIOS() && inMiniprograme.value
  })
}

export const coinJsPreOrder = (coinKey: string, miniApp: boolean) => {
  return netClient.request<CommonResponse<CreateWechatOrderResponse>>(COIN_JS_ORDER, 'post', {
    coinKey: coinKey,
    miniApp: miniApp
  })
}

export const coinNativeQrOrder = (coinKey: string) => {
  return netClient.request<CommonResponse<CreateOrderNativeResponse>>(COIN_QR_ORDER, 'post', { coinKey: coinKey })
}

export interface CoinTradeRecordDTO {
  id: number
  accountId: string
  amount: number
  type: string // 新值： 'offering'
  after: number
  orderId: string
  giftId: string
  gift: MemorialGiftDTO
  serviceId: string
  activityId: string
  bonusId: string
  operatorId: string
  createdAt: number
  offeringSummary: string // 增加了供奉消费的描述；如果type='offering',就展示这个
}

export interface CoinTradeResponse {
  id: string
  pageSize: number
  total: number
  items: Array<CoinTradeRecordDTO>
}

export function getCoinTradeRecord(last: number, pageSize: number) {
  return netClient.request<CommonResponse<CoinTradeResponse>>(COIN_TRADE_LIST, 'get', {
    last: last,
    pageSize: pageSize
  })
}
